<template>
  <EditableInfoField 
    :label="$t('Телефон для связи с гостем')" 
    :items="items"
    :value="modelNumber"
    prepend-icon="mdi-chevron-left"
    @focus.prevent="e => $store.dispatch('inputFocus', e)"
    kbd-layout="numpad"
    ref="field"
    :rules="rules"
  >
    <template #hint="{ }">
      <v-btn test-tag="tag-105" @click="() => { focus() }" :disabled="!!modelValue.id" icon color="primary" small class="mr-2">
        <v-icon>mdi-pen</v-icon>
      </v-btn>
    </template>

    <template #editor="{blurEditable, setEditable}">
      <!-- <vue-tel-input
        :validCharactersOnly="true"
        @focus="e => $store.dispatch('inputFocus', e)"
        v-model="modelNumber"
      /> -->
      <!-- <v-form @submit.prevent="blurEditable" ref="form"> -->
        <PhoneField
          v-bind="{...$attrs, value: null}" 
          v-on="{...$listeners, input: null}" 
          :rules="rules"
          v-model="modelNumber"
          append-outer-icon="mdi-check"
          :label="$t('Телефон для связи с гостем')" 
          prepend-icon="mdi-chevron-left"
          kbd-layout="numpad"
          kbd-no-caret
          ref="editor"
          
          @focus.prevent="setEditable(true)"

          @click:append-outer="blurEditable"
          @click:prepend="rollbackEdit"
        />
      <!-- </v-form> -->
    </template>

    <v-menu offset-y>
      <template #activator="{on, attrs}">
        <v-btn test-tag="tag-106" v-on="on" v-bind="attrs" text class="pl-0"> 
          <v-icon v-if="modelValue.id" small class="mr-2">mdi-phone</v-icon>
          <v-icon v-else small class="mr-2">mdi-phone-clock</v-icon>
          <PhoneFormatter :value="value.number" />
          <v-icon>mdi-menu-down</v-icon>
        </v-btn>
        <!-- <v-btn test-tag="tag-107" @click="makeEditable" class="ml-5" :disabled="!!modelValue.id" small icon color="primary"><v-icon>mdi-pen</v-icon></v-btn> -->
      </template>
      <v-list dense>
        <v-list-item test-tag="tag-112" v-for="item in items" :key="item.id"  @click="modelValue = item">
          <v-list-item-avatar><v-icon>mdi-phone</v-icon></v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              <PhoneFormatter :value="item.number" />
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-dialog max-width="600" v-model="dialog" persistent>
              <template #activator="{ on, attrs }">
                <v-btn test-tag="tag-108" v-on="on" v-bind="attrs" icon color="error" small><v-icon>mdi-trash-can-outline</v-icon></v-btn>
              </template>
              <v-card>
                <v-card-title test-tag="tag-115"><T>Удаление номера телефона</T></v-card-title>
                <v-card-text>Это действие приведет к удалению номера телефона гостя "<b><PhoneFormatter :value="item.number" /></b>"<br> Продолжить?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn test-tag="tag-109" type="reset" color="black" text @click="dialog = false"> <v-icon>mdi-close</v-icon><T>Отмена</T></v-btn>
                  <v-btn test-tag="tag-110" color="primary" text @click="() => { dialog = false; removePhone(item) }"> <v-icon>mdi-check</v-icon><T>Удалить</T></v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list-item-action>
        </v-list-item>
        <v-list-item test-tag="tag-113" v-if="lastLocalPhone" @click="modelValue = lastLocalPhone">
          <v-list-item-avatar><v-icon >mdi-phone-clock</v-icon></v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              <PhoneFormatter :value="lastLocalPhone.number"/>
            </v-list-item-title>
            <v-list-item-subtitle><T>Добавлен только что</T></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn test-tag="tag-111" @click="rollbackNewPhone" icon color="error" small><v-icon>mdi-trash-can-outline</v-icon></v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item test-tag="tag-114" @click="makeEditable">
          <v-list-item-avatar><v-icon color="primary">mdi-plus</v-icon></v-list-item-avatar>
          <v-list-item-title><T>Добавить телефон</T></v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </EditableInfoField>
</template>

<script>
import EditableInfoField from '@/components/common/EditableInfoField'
import PhoneField from '@/components/common/PhoneField'
import PhoneFormatter from '@/components/common/PhoneFormatter'

export default {
  props: {
    value: [Object, undefined],
    items: Array,
    default: [Object, undefined],
    rules: Array
  },
  data: () => ({
    lastLocalPhone: undefined,
    dialog: false
  }),
  methods: {
    makeEditable() {
      // this.modelValue = this.lastLocalPhone ? this.lastLocalPhone.id ? {number: ''} : this.lastLocalPhone : {number: ''}
      this.modelValue = {number: ''}
      this.$refs.field.makeEditable()
      this.focus()
    },
    removePhone(phone) {
      if (this.value?.id == phone.id) {
        if (this.lastLocalPhone) {
          this.$emit("input", this.lastLocalPhone)
        } else {
          if (this.default?.id != phone.id) {
            this.$emit("input", this.default)
          } else {
            this.$emit("input", this.items.filter(el => el.id != phone.id)[0]) // it's ok to emit undefined
          }
        }
      }
      this.$emit('removePhone', phone)
    },
    rollbackEdit() {
      if (!this.lastLocalPhone?.number) {
        this.lastLocalPhone = undefined
        this.$emit('input', this.default ? this.default : this.items[0])
      }
      this.$refs.field.blurEditable()
    },
    rollbackNewPhone(){
      this.lastLocalPhone = undefined
      
      if (!this.value.id) {// current selected phone is the new phone
        this.$emit('input', this.default ? this.default : this.items[0])
      }

      this.$refs.field.blurEditable()
    },
    focus() {
      console.log('call focus')
      this.$refs.field.focus()
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.editor.$el.getElementsByTagName('input')[0].focus()
        })
      }, 200)
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(v) {
        if (!v.id) {
          this.lastLocalPhone = v
        }
        this.$emit('input', v)
      }
    },
    modelNumber: {
      get() {
        return this.modelValue?.number
      },
      set(number) {
        if (number === null) {
          this.lastLocalPhone = { number: '' } 
          this.rollbackEdit()
        } else {
          if (number === '') {
            this.lastLocalPhone = undefined
          } else {
            this.lastLocalPhone = { number } 
          }
          this.$emit('input', {...this.modelValue, number})
        }       
      }
    }
  },
  mounted() {
    if (!this.modelValue?.id) {
      this.lastLocalPhone = this.modelValue
    }
  },
  components: {
    EditableInfoField,
    PhoneField,
    PhoneFormatter
  }
}
</script>